var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessorFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2055_9590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_2055_9590)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9668 33.416C61.9672 32.9427 62.5892 32.6468 62.9795 33.0371C65.4454 35.503 69.7438 39.8502 72.1455 42.2686L72.1465 42.2705C72.4686 42.5929 72.2631 43.2002 71.7168 43.2002C69.8326 43.2002 67.6358 43.2002 66.0557 43.1836H66.0498C63.7962 43.1834 61.9669 41.3773 61.9668 39.2334V33.416Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4497 32.833H57.5161C58.1566 32.833 58.6831 33.3595 58.6831 34V38.8164C58.6831 43.0425 62.124 46.4834 66.3501 46.4834H71.1665C71.8069 46.4834 72.3334 47.009 72.3335 47.6494V56.3828C72.3335 59.2352 71.3418 61.4191 69.7739 62.8916C68.2012 64.3686 66.0096 65.1659 63.5503 65.166H50.4497C47.9902 65.166 45.7979 64.3688 44.2251 62.8916C42.6573 61.4191 41.6665 59.2351 41.6665 56.3828V41.6162L41.6782 41.0898C41.7928 38.4941 42.7552 36.488 44.2251 35.1074C45.6995 33.7226 47.7186 32.9359 49.9917 32.8428L50.4497 32.833ZM49.4995 55.583C48.5402 55.5832 47.7495 56.3736 47.7495 57.333C47.7495 58.2924 48.5402 59.0828 49.4995 59.083H56.1665C57.126 59.083 57.9165 58.2925 57.9165 57.333C57.9165 56.3735 57.126 55.583 56.1665 55.583H49.4995ZM49.4995 48.916C48.5403 48.9162 47.7497 49.7068 47.7495 50.666C47.7495 51.6254 48.5402 52.4158 49.4995 52.416H59.4995C60.459 52.416 61.2495 51.6255 61.2495 50.666C61.2493 49.7067 60.4589 48.916 59.4995 48.916H49.4995Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2055_9590",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_9590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_9590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2055_9590",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessorFolder);
export default __webpack_public_path__ + "static/media/processorFolder.9cbb8aa2f0bf35a079e4fcd493a92c33.svg";
export { ForwardRef as ReactComponent };